/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconClearAll = createReactComponent("clear-all", "IconClearAll", [
  ["path", { d: "M8 6h12", key: "svg-0" }],
  ["path", { d: "M6 12h12", key: "svg-1" }],
  ["path", { d: "M4 18h12", key: "svg-2" }]
]);

export { IconClearAll as default };
//# sourceMappingURL=IconClearAll.js.map
